import { DirectCompanyResponse } from "../../features/api-interfaces";
import { formatLabel } from "../../utils/format";
import {
  COMMON_LABELS,
  DivisionDict,
  shopReceiveUnitMethodPattern,
} from "../default-constants";
import { CONTENTS } from "./constants";

/**
 * APIから受け取った申請事業者リストを整形する.
 * @param {DirectCompanyResponse[] | undefined} companies APIから受け取った申請事業者リスト
 * @returns {DivisionDict[]} 申請事業者リストの選択肢オブジェクト
 */
export const getApplicantCompanyItems = (
  companies: DirectCompanyResponse[] | undefined
): DivisionDict[] => {
  if (companies !== undefined) {
    return companies.map((companies) => ({
      label: companies.companyName,
      value: companies.applicantCompanyCode,
    }));
  }
  return [];
};

/**
 * 引数で受け取った申請事業者コードを基に申請事業者の店舗情報取込単位を取得する.
 * @param {DirectCompanyResponse[] | undefined} dirApplicantCompanies 申請事業者リスト
 * @param {string} companyCode 申請事業者コード
 * @returns {number} 店舗情報取込単位
 */
export const getShopReceiveUnitMethod = (
  dirApplicantCompanies: DirectCompanyResponse[] | undefined,
  companyCode: string
): number => {
  return (
    dirApplicantCompanies?.find(
      (company) => company.applicantCompanyCode === companyCode
    )?.shopReceiveUnitMethod ??
    Number(shopReceiveUnitMethodPattern.difference.value)
  );
};

/**
 * 店舗情報取込単位ラベルを返却する.
 * 1: 差分更新, 2: 全量更新
 * @param {number} shopReceiveUnitMethod 店舗情報取込単位コード値
 * @returns {string} 店舗情報取込単位ラベル
 */
export const getShopReceiveUnitMethodLabel = (
  shopReceiveUnitMethod: number
): string => {
  const { difference, all } = shopReceiveUnitMethodPattern;
  switch (shopReceiveUnitMethod.toString()) {
    case difference.value:
      return difference.label;
    case all.value:
      return all.label;
    default:
      return "";
  }
};

/**
 * 申請パターンによってダイアログのメッセージを変える.
 * @param {boolean} isAllApplication 全量申請か
 * @param {number} closedStoreCount 閉店店舗数
 * @param {string} fileName アップロードしたファイル名
 * @returns {string} ダイアログのメッセージ
 */
export const getContentMessage = (
  isAllApplication: boolean,
  closedStoreCount: number,
  fileName: string
) => {
  let contentMessage = "";

  if (isAllApplication) {
    contentMessage = formatLabel(CONTENTS.CLOSED_STORE_COUNT_CONTENT, [
      closedStoreCount,
    ]);
    contentMessage +=
      closedStoreCount !== 0 ? CONTENTS.ALL_APPLICATION_CONFIRM : "\r\n";
  }
  contentMessage +=
    COMMON_LABELS.CONTENTS.APPLICATION_CONFIRM +
    formatLabel(CONTENTS.APPLICATION_CONFIRM, [fileName]);

  return contentMessage;
};
